// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"c83c8455","461":"7e0e043a","548":"29d76e9e","645":"947dff15","818":"6e24e6d1"}[chunkId] + ".chunk.js";
};